<template>
  <v-card
    class="queue-item"
    @click.native="gotoDetail(itemData)"
    :color="`${itemData.lockedBy ? lockedColor : `${isAssignedBPQ ? defaultColor : activeColor}`}`"
    @mouseenter="mouseEnter(itemData)"
    @mouseleave="mouseLeave(itemData)"
    :style="`${itemData.lockedBy ? 'box-shadow: none;' :'box-shadow: 0px 4px 8px 0px rgba(191,206,222,0.25);'}`"
  >
    <!-- card title -->
    <!--
    <v-card-title>
      <v-layout v-if="layoutSetting.title">
        <v-flex>
          <span>{{ tool.fieldRender(itemData, layoutSetting.title[0].template) }}</span>
          <span>
            <i v-if="itemData[layoutSetting.title[1].fieldKey]" :class="layoutSetting.title[1].icon"></i>
            <i v-if="itemData.lockInfo" :class="layoutSetting.title[1].icon"></i>
          </span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex :class="layoutSetting.title[2].valueClass" v-if="layoutSetting.title[2] && itemData[layoutSetting.title[2].fieldKey]">
          <span>{{ tool.fieldRender(itemData, layoutSetting.title[2].template, layoutSetting.title[2].format) }}</span>
        </v-flex>
      </v-layout>
    </v-card-title>
    -->
    <template v-if="!isEnter">
      <v-card-title>
      <v-layout v-if="layoutSetting.title" style="margin-top: 2px;">
        <div :style="{background: color}" class="tableShow"></div>
        <div class="tableLoanDetails">
          <div class="tableLoanNo">
            <span>{{ tool.fieldRender(itemData, layoutSetting.title[0].template) }}</span>
            <span class="locked-icon">
              <img v-if="itemData[layoutSetting.title[1].fieldKey]" :src="computeLogo"/>
              <img v-if="itemData.lockInfo" :src="computeLogo"/>
              <!--
              <i v-if="itemData[layoutSetting.title[1].fieldKey]" :class="layoutSetting.title[1].icon"></i>
              <i v-if="itemData.lockInfo" :class="layoutSetting.title[1].icon"></i>
              -->
            </span>
          </div>
          <v-layout v-if="layoutSetting.subTitle" class="tableName">
            <v-flex>
              <span class="subheader">
                {{ tool.fieldRender(itemData, layoutSetting.subTitle[0].template) }}
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="text-right" v-if="itemData[layoutSetting.subTitle[1].fieldKey]">
              <v-chip
                class="m-v-5"
                :color="layoutSetting.color[0]"
                label
                x-small
                outlined
              >
                {{ tool.fieldRender(itemData, layoutSetting.subTitle[1].template, null, { source: dataType.Source }) }}
              </v-chip>
            </v-flex>
          </v-layout>
          <div class="tableRequestedAmount" :class="layoutSetting.title[2].valueClass" v-if="layoutSetting.title[2] && itemData[layoutSetting.title[2].fieldKey]">
            <span>{{ tool.fieldRender(itemData, layoutSetting.title[2].template, layoutSetting.title[2].format) }}</span>
          </div>
        </div>
      </v-layout>
      <div class="line"></div>
    </v-card-title>
    <v-card-text>
      <!-- card subTitle -->
      <!--
      <v-layout v-if="layoutSetting.subTitle">
        <v-flex>
          <span class="subheader">
            {{ tool.fieldRender(itemData, layoutSetting.subTitle[0].template) }}
          </span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-right" v-if="itemData[layoutSetting.subTitle[1].fieldKey]">
          <v-chip
            class="m-v-5"
            :color="layoutSetting.color[0]"
            label
            x-small
            outlined
          >
            {{ tool.fieldRender(itemData, layoutSetting.subTitle[1].template, null, { source: dataType.Source }) }}
          </v-chip>
        </v-flex>
      </v-layout>
      -->
      <!-- card content -->
      <!--
      <template v-for="(field, index) of layoutSetting.sectionFields">
        <v-layout v-if="field.children" :key="index">
          <template v-for="(child, cIndex) of field.children">
            <v-flex v-if="itemData[child.fieldKey]" :key="cIndex">
              <label :class="child.labelClass">{{ child.label }}</label>
              <span :class="child.valueClass"> {{ tool.fieldRender(itemData, child.template, child.format) }}</span>
            </v-flex>
          </template>
        </v-layout>
        <v-layout v-else-if="field.template === 'checkIcon'" :key="index">
          <v-flex :class="field.labelClass" v-if="field.label">
            <label>{{ field.label }}</label>
          </v-flex>
          <v-flex :class="field.valueClass">
            <v-icon v-if="itemData[field.fieldKey] === dataType.SignStatusEnum.SIGNED.value" style="font-size: 20px !important;" color="primary">check</v-icon>
            <v-icon small v-else style="font-size: 14px !important;">fas fa-question</v-icon>
          </v-flex>
        </v-layout>
        <v-layout v-else :key="index">
          <template v-if="itemData[field.fieldKey] && field.fieldKey !=='auditedBy' || (tool.isNotEmpty(itemData[field.fieldKey]) && field.fieldKey ==='auditedBy' && dataType.LoanStatus.UNDERWRITER_REVIEW.value === itemData.loanStatus)">
            <v-flex :class="field.labelClass" v-if="field.label">
              <label>{{ field.label }}</label>
            </v-flex>
            <v-flex :class="field.valueClass">
              <v-divider v-if="field.divider"></v-divider>
              <template v-if="tool.isNotEmpty(field.fieldKey) && operationByArray.includes(field.fieldKey)">
                <span>{{ tool.fieldRender(getOperatorNameInfo(itemData[field.fieldKey], field.fieldKey), field.template, field.format) }}</span>
              </template>
              <template v-else>
                <span>{{ tool.fieldRender(itemData, field.template, field.format) }}</span>
              </template>
            </v-flex>
            <v-flex v-if="field.fieldKey === 'loanStatusText' && isLos(itemData) && (sameDayIcon.display || returningIcon.display)" class="text-right">
              <span>
                <v-tooltip bottom v-if="sameDayIcon.display">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                    </v-btn>
                  </template>
                  <span>Same Day</span>
                </v-tooltip>
                <v-tooltip bottom v-if="returningIcon.display && isDisplayIcon(dataType.PrivilegeCode.RETURNING_QUEUE)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <span class="material-icons" :style="returningIcon.color">{{ returningIcon.style }}</span>
                    </v-btn>
                  </template>
                  <span>{{ returningIcon.title }}</span>
                </v-tooltip>
              </span>
            </v-flex>
          </template>
        </v-layout>
      </template>
      -->
      <template v-for="(field, index) of layoutSetting.sectionFields">
        <v-layout v-if="field.children" :key="index">
          <template v-for="(child, cIndex) of field.children">
            <v-flex v-if="itemData[child.fieldKey]" :key="cIndex">
              <label :class="child.labelClass">{{ child.label }}</label>
              <span :class="child.valueClass"> {{ tool.fieldRender(itemData, child.template, child.format) }}</span>
            </v-flex>
          </template>
        </v-layout>
        <v-layout v-else-if="field.template === 'checkIcon'" :key="index">
          <v-flex :class="field.labelClass" v-if="field.label">
            <label class="card-label">{{ field.label }}</label>
          </v-flex>
          <v-flex :class="field.valueClass">
            <v-icon v-if="itemData[field.fieldKey] === dataType.SignStatusEnum.SIGNED.value" style="font-size: 20px !important;" color="#7E829B !important">check</v-icon>
            <v-icon small v-else style="font-size: 14px !important;" color="#7E829B !important">fas fa-question</v-icon>
          </v-flex>
        </v-layout>
        <v-layout v-else :key="index">
          <template v-if="itemData[field.fieldKey] && field.fieldKey !=='auditedBy' || (tool.isNotEmpty(itemData[field.fieldKey]) && field.fieldKey ==='auditedBy' && dataType.LoanStatus.UNDERWRITER_REVIEW.value === itemData.loanStatus)">
            <v-flex :class="field.labelClass" v-if="field.label">
              <label class="card-label">{{ field.label }}</label>
            </v-flex>
            <v-flex :class="field.valueClass" class="card-content">
              <v-divider v-if="field.divider"></v-divider>
              <template v-if="tool.isNotEmpty(field.fieldKey) && operationByArray.includes(field.fieldKey)">
                <span v-if="isShowOperatedBy" :title="tool.fieldRender(getOperatorNameInfo(itemData[field.fieldKey], field.fieldKey), field.template, field.format)">{{ tool.fieldRender(getOperatorNameInfo(itemData[field.fieldKey], field.fieldKey), field.template, field.format) }}</span>
                <span v-else :title="tool.formatOperatedAction(tool.getOperatedActionByOperatedBy(itemData[field.fieldKey], roleList, $store.getters.getAccount))">
                  {{ tool.formatRoleCode(tool.getOperatedActionByOperatedBy(itemData[field.fieldKey], roleList, $store.getters.getAccount)) }}
                </span>
              </template>
              <template v-else>
                <span v-if="field.fieldKey === 'loanStatusText'" class="card-label">{{ tool.fieldRender(itemData, field.template, field.format) }}</span>
                <span v-else>{{ tool.fieldRender(itemData, field.template, field.format) }}</span>
              </template>
            </v-flex>
            <v-flex v-if="field.fieldKey === 'loanStatusText' && ((isLos(itemData) && (sameDayIcon.display || returningIcon.display || reSentIcon.display)) || creditCardIcon.display || compressIcon.display || foxExpressIcon.display)" class="text-right">
              <span>
                <v-tooltip bottom v-if="sameDayIcon.display">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                    </v-btn>
                  </template>
                  <span>Same Day</span>
                </v-tooltip>
                <v-tooltip bottom v-if="returningIcon.display && isDisplayIcon(dataType.PrivilegeCode.RETURNING_QUEUE)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <span class="material-icons" :style="returningIcon.color">{{ returningIcon.style }}</span>
                    </v-btn>
                  </template>
                  <span>{{ returningIcon.title }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="reSentIcon.display && isDisplayIcon(dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE)">
                  <template v-slot:activator="{ on }">
                    <v-icon style="color: orange!important;" color="orange!important" small slot="activator" v-on="on">published_with_changes</v-icon>
                  </template>
                  <span>Re-Sent to UW</span>
                </v-tooltip>
                <v-tooltip bottom v-if="creditCardIcon.display">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                    </v-btn>
                  </template>
                  <span>Credit Card</span>
                </v-tooltip>
                <v-tooltip bottom v-if="compressIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                      </v-btn>
                    </template>
                    <span>compress</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="foxExpressIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: #d32f2f !important;">support</span>
                      </v-btn>
                    </template>
                    <span>Fox Express</span>
                  </v-tooltip>
              </span>
              </v-flex>
          </template>
        </v-layout>
      </template>
    </v-card-text>
    </template>
    <template v-else>
      <v-card-title>
      <v-layout v-if="layoutSetting.title" style="margin-top: 2px;">
        <div style="background: #fff" class="tableShow"></div>
        <div class="tableLoanDetails">
          <div class="tableLoanNo-hover">
            <span>{{ tool.fieldRender(itemData, layoutSetting.title[0].template) }}</span>
            <span class="locked-icon">
              <img v-if="itemData[layoutSetting.title[1].fieldKey]" :src="computeLogo"/>
              <img v-if="itemData.lockInfo" :src="computeLogo"/>
              <!--
              <i v-if="itemData[layoutSetting.title[1].fieldKey]" :class="layoutSetting.title[1].icon"></i>
              <i v-if="itemData.lockInfo" :class="layoutSetting.title[1].icon"></i>
              -->
            </span>
          </div>
          <v-layout v-if="layoutSetting.subTitle" class="tableName-hover">
            <v-flex>
              <span class="subheader">
                {{ tool.fieldRender(itemData, layoutSetting.subTitle[0].template) }}
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex class="text-right" v-if="itemData[layoutSetting.subTitle[1].fieldKey]">
              <v-chip
                class="m-v-5"
                :color="layoutSetting.color[0]"
                label
                x-small
                outlined
              >
                {{ tool.fieldRender(itemData, layoutSetting.subTitle[1].template, null, { source: dataType.Source }) }}
              </v-chip>
            </v-flex>
          </v-layout>
          <div class="tableRequestedAmount-hover" :class="layoutSetting.title[2].valueClass" v-if="layoutSetting.title[2] && itemData[layoutSetting.title[2].fieldKey]">
            <span>{{ tool.fieldRender(itemData, layoutSetting.title[2].template, layoutSetting.title[2].format) }}</span>
          </div>
        </div>
      </v-layout>
      <div class="line-hover"></div>
    </v-card-title>
    <v-card-text>
      <template v-for="(field, index) of layoutSetting.sectionFields">
        <v-layout v-if="field.children" :key="index">
          <template v-for="(child, cIndex) of field.children">
            <v-flex v-if="itemData[child.fieldKey]" :key="cIndex">
              <label :class="child.labelClass">{{ child.label }}</label>
              <span :class="child.valueClass"> {{ tool.fieldRender(itemData, child.template, child.format) }}</span>
            </v-flex>
          </template>
        </v-layout>
        <v-layout v-else-if="field.template === 'checkIcon'" :key="index">
          <v-flex :class="field.labelClass" v-if="field.label">
            <label class="card-label-hover">{{ field.label }}</label>
          </v-flex>
          <v-flex :class="field.valueClass">
            <v-icon v-if="itemData[field.fieldKey] === dataType.SignStatusEnum.SIGNED.value" style="font-size: 20px !important;" color="#fff !important">check</v-icon>
            <v-icon small v-else style="font-size: 14px !important;" color="#fff !important">fas fa-question</v-icon>
          </v-flex>
        </v-layout>
        <v-layout v-else :key="index">
          <template v-if="itemData[field.fieldKey] && field.fieldKey !=='auditedBy' || (tool.isNotEmpty(itemData[field.fieldKey]) && field.fieldKey ==='auditedBy' && dataType.LoanStatus.UNDERWRITER_REVIEW.value === itemData.loanStatus)">
            <v-flex :class="field.labelClass" v-if="field.label">
              <label class="card-label-hover">{{ field.label }}</label>
            </v-flex>
            <v-flex :class="field.valueClass" class="card-content-hover">
              <v-divider v-if="field.divider"></v-divider>
              <template v-if="tool.isNotEmpty(field.fieldKey) && operationByArray.includes(field.fieldKey)">
                <span v-if="isShowOperatedBy" :title="tool.fieldRender(getOperatorNameInfo(itemData[field.fieldKey], field.fieldKey), field.template, field.format)">{{ tool.fieldRender(getOperatorNameInfo(itemData[field.fieldKey], field.fieldKey), field.template, field.format) }}</span>
                <span v-else :title="tool.formatOperatedAction(tool.getOperatedActionByOperatedBy(itemData[field.fieldKey], roleList, $store.getters.getAccount))">
                  {{ tool.formatRoleCode(tool.getOperatedActionByOperatedBy(itemData[field.fieldKey], roleList, $store.getters.getAccount)) }}
                </span>
              </template>
              <template v-else>
                <span v-if="field.fieldKey === 'loanStatusText'" class="card-label-hover">{{ tool.fieldRender(itemData, field.template, field.format) }}</span>
                <span v-else>{{ tool.fieldRender(itemData, field.template, field.format) }}</span>
              </template>
            </v-flex>
            <v-flex v-if="field.fieldKey === 'loanStatusText' && ((isLos(itemData) && (sameDayIcon.display || returningIcon.display || reSentIcon.display)) || creditCardIcon.display || compressIcon.display || foxExpressIcon.display)" class="text-right">
              <span>
                <v-tooltip bottom v-if="sameDayIcon.display">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <i class="fab fa-hotjar" style="color: #D32F2F !important;"></i>
                    </v-btn>
                  </template>
                  <span>Same Day</span>
                </v-tooltip>
                <v-tooltip bottom v-if="returningIcon.display && isDisplayIcon(dataType.PrivilegeCode.RETURNING_QUEUE)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <span class="material-icons" :style="returningIcon.color">{{ returningIcon.style }}</span>
                    </v-btn>
                  </template>
                  <span>{{ returningIcon.title }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="reSentIcon.display && isDisplayIcon(dataType.PrivilegeCode.UNDERWRITER_REVIEW_QUEUE)">
                  <template v-slot:activator="{ on }">
                    <v-icon style="color: orange!important;" color="orange!important" small slot="activator" v-on="on">published_with_changes</v-icon>
                  </template>
                  <span>Re-Sent to UW</span>
                </v-tooltip>
                <v-tooltip bottom v-if="creditCardIcon.display">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                    >
                      <span class="material-icons" style="color: #D32F2F !important;">credit_card</span>
                    </v-btn>
                  </template>
                  <span>Credit Card</span>
                </v-tooltip>
                <v-tooltip bottom v-if="compressIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: #d32f2f !important;">compress</span>
                      </v-btn>
                    </template>
                    <span>compress</span>
                  </v-tooltip>
                <v-tooltip bottom v-if="foxExpressIcon.display">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn  icon
                              x-small
                              slot="activator"
                              class="action-button"
                              v-on="on"
                              v-bind="attrs"
                              width="27px"
                      >
                        <span class="material-icons" style="color: #d32f2f !important;">support</span>
                      </v-btn>
                    </template>
                    <span>Fox Express</span>
                  </v-tooltip>
              </span>
            </v-flex>
          </template>
        </v-layout>
      </template>
    </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { Tool, DataType, Crypto, Cache, Authentication } from '@/util/index'
import locked from '@/assets/images/icon_lock.png'
const tool = new Tool()
const cache = new Cache()
export default {
  name: 'arb-application-queue-item',
  props: {
    itemData: {
      type: Object
    },
    color: {
      type: String,
      default: 'white'
    },
    secondColor: {
      typeof: String
    },
    layoutSetting: {
      type: Object
    },
    loanPhase: Number,
    queueCode: String,
    privileges: {
      type: Array,
      default: () => []
    },
    roleList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      tool: new Tool(),
      dataType: DataType,
      activeColor: 'white',
      losWorkQueueLoanStatus: [
        DataType.LoanStatus.AGENT_REVIEW.value, DataType.LoanStatus.CORRECTOR_REVIEW.value, DataType.LoanStatus.UNDERWRITER_REVIEW.value, DataType.LoanStatus.TRIBE_REVIEW.value,
        DataType.LoanStatus.POSITIVE_WITHDRAWN.value, DataType.LoanStatus.NEGATIVE_WITHDRAWN.value
      ],
      operationByArray: ['submittedBy', 'auditedBy', 'rejectedBy', 'lockedBy'],
      sameDayIcon: {
        display: false
      },
      returningIcon: {
        style: null,
        color: null,
        title: null,
        display: false
      },
      reSentIcon: {
        style: null,
        color: null,
        title: null,
        display: false
      },
      creditCardIcon: {
        display: false
      },
      compressIcon: {
        display: false
      },
      foxExpressIcon: {
        display: false
      },
      isEnter: false,
      lockedColor: this.secondColor
    }
  },
  computed: {
    assignedId () {
      return this.store.getters.getAccount.id
    },
    isAssignedBPQ () {
      return tool.isNotEmpty(this.itemData.assignedId) && this.assignedId === this.itemData.assignedId && this.itemData.loanStatus === DataType.LoanStatus.IN_HOUSE_REJECTED.value
    },
    defaultColor () {
      if (this.isAssignedBPQ) {
        return 'purple'
      }
      return 'white'
    },
    computeLogo () {
      return locked
    },
    isShowOperatedBy () {
      return Authentication.matchElementPrivilege(this.privileges, DataType.PrivilegeCode.SHOW_OPERATED_BY, DataType.PrivilegeType.EXECUTABLE)
    }
  },
  watch: {
    itemData: {
      handler: function (value) {
        this.uploadIcon(value)
      },
      immediate: true
    }
  },
  methods: {
    mouseEnter (itemData) {
      this.isEnter = true
      if (itemData.lockedBy) {
        this.lockedColor = this.color
      } else {
        this.activeColor = this.color
      }
    },
    mouseLeave (itemData) {
      this.isEnter = false
      if (itemData.lockedBy) {
        this.lockedColor = this.secondColor
      } else {
        this.activeColor = this.defaultColor
      }
    },
    isDisplayIcon (privilegeCode) {
      return this.queueCode === privilegeCode
    },
    getOperatorNameInfo (data) {
      return tool.isNotEmpty(data) ? ((tool.isNotEmpty(JSON.parse(data).id) && JSON.parse(data).id === -1) ? { firstName: 'VA DONE' } : JSON.parse(data)) : { firstName: 'Unknow' }
    },
    gotoDetail (itemData) {
      if (tool.isNotEmpty(itemData)) {
        this.$eventBus.$emit('side-icon-click')
        this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.AUTOMATIC_LOCK.value)
        this.pushPath(this.layoutSetting.name, Crypto.encrypt(itemData.id))
      }
    },
    pushPath (sectionName, id) {
      if (this.loanPhase === DataType.LoanPhaseEnum.LOAN_ORIGINATION.value) {
        cache.setSessionLoanId(id)
        this.$router.push('/{0}/application'.format(sectionName))
      } else {
        this.$router.push('/{0}/application/{1}'.format(sectionName, id))
        cache.removeSessionLoanId()
      }
    },
    uploadIcon (itemData) {
      if (tool.isNotEmpty(itemData)) {
        const effectiveDate = tool.isNotEmpty(itemData.effectiveDate) ? parseInt(itemData.effectiveDate) : 0
        const currentTimestamp = tool.isNotEmpty(itemData.currentTimestamp) ? parseInt(itemData.currentTimestamp) : 0
        if (effectiveDate >= currentTimestamp && effectiveDate <= currentTimestamp + 24 * 3600 * 1000 - 1) {
          this.sameDayIcon = {
            display: true
          }
        }

        const flags = itemData.flags
        const tags = itemData.tags
        if (DataType.LoanFlagsEnum.INSTANT_FUND.value === (flags & DataType.LoanFlagsEnum.INSTANT_FUND.value)) {
          this.creditCardIcon = {
            display: true
          }
        }
        if (DataType.LoanTagsEnum.COMPRESS_SIGNATURE_LINK.value === (tags & DataType.LoanTagsEnum.COMPRESS_SIGNATURE_LINK.value)) {
          this.compressIcon = {
            display: true
          }
        }
        if (DataType.LoanFlagsEnum.FOX_EXPRESS.value === (flags & DataType.LoanFlagsEnum.FOX_EXPRESS.value)) {
          this.foxExpressIcon = {
            display: true
          }
        }
        if (DataType.LoanTagsEnum.SP_PO_WITHOUT_COLLECTION.value === (tags & DataType.LoanTagsEnum.SP_PO_WITHOUT_COLLECTION.value) || DataType.LoanTagsEnum.SP_CLOSE.value === (tags & DataType.LoanTagsEnum.SP_CLOSE.value)) {
          this.returningIcon = {
            style: 'done_all',
            color: 'color: green !important;',
            title: 'Paid Off',
            display: true
          }
        } else if (DataType.LoanTagsEnum.DP_PO_WITHOUT_COLLECTION.value === (tags & DataType.LoanTagsEnum.DP_PO_WITHOUT_COLLECTION.value) || DataType.LoanTagsEnum.DP_CLOSE.value === (tags & DataType.LoanTagsEnum.DP_CLOSE.value)) {
          this.returningIcon = {
            style: 'done_all',
            color: 'color: orange !important;',
            title: 'Paid Off',
            display: true
          }
        } else if (DataType.LoanTagsEnum.SP_PO_COLLECTION.value === (tags & DataType.LoanTagsEnum.SP_PO_COLLECTION.value) || DataType.LoanTagsEnum.SP_PO_COLLECTION_REJECT.value === (tags & DataType.LoanTagsEnum.SP_PO_COLLECTION_REJECT.value) || DataType.LoanTagsEnum.SP_ELSE_REJECT.value === (tags & DataType.LoanTagsEnum.SP_ELSE_REJECT.value)) {
          this.returningIcon = {
            style: 'sync_alt',
            color: 'color: green !important;',
            title: 'Loan Transfer',
            display: true
          }
        } else if (DataType.LoanTagsEnum.DP_GOOD_RATIO.value === (tags & DataType.LoanTagsEnum.DP_GOOD_RATIO.value) || DataType.LoanTagsEnum.DP_PO_COLLECTION.value === (tags & DataType.LoanTagsEnum.DP_PO_COLLECTION.value) || DataType.LoanTagsEnum.DP_ELSE.value === (tags & DataType.LoanTagsEnum.DP_ELSE.value)) {
          this.returningIcon = {
            style: 'sync_alt',
            color: 'color: orange !important;',
            title: 'Loan Transfer',
            display: true
          }
        } else if (DataType.LoanTagsEnum.SP_GOOD_REJECT.value === (tags & DataType.LoanTagsEnum.SP_GOOD_REJECT.value)) {
          this.returningIcon = {
            style: 'price_check',
            color: 'color: green !important;',
            title: 'Good D/C',
            display: true
          }
        } else if (DataType.LoanTagsEnum.DP_GOOD.value === (tags & DataType.LoanTagsEnum.DP_GOOD.value)) {
          this.returningIcon = {
            style: 'price_check',
            color: 'color: orange !important;',
            title: 'Good D/C',
            display: true
          }
        } else if (DataType.LoanTagsEnum.ROCKET_CREDIT.value === (tags & DataType.LoanTagsEnum.ROCKET_CREDIT.value)) {
          this.returningIcon = {
            style: 'flash_on',
            color: 'color: green !important;',
            title: 'Rocket Credit',
            display: true
          }
        }

        if (itemData.auditedBy) {
          this.reSentIcon = {
            display: true
          }
        }
      }
    },
    isLos (itemData) {
      return this.losWorkQueueLoanStatus.includes(itemData.loanStatus)
    }
  }
}
</script>

<style lang="css" scoped>
.queue-item {
  font-size: 10px !important;
  border-radius: 4px;
  cursor: pointer;
  /*max-width: 305px !important;*/
  /*min-width: 305px !important;*/
  white-space: nowrap;
  margin: 10px 0;
}
/*.queue-item + .queue-item {*/
/*  margin-top: 10px;*/
/*}*/
.queue-item span + span {
  margin-left: 5px;
}
.queue-item .flex {
  padding: 5px 10px !important;
}
.queue-item .v-card__text .flex {
  padding: 2px 10px !important;
}
.queue-item .subheader {
  font-size: 14px !important;
  line-height: unset;
}
.queue-item .tag {
  min-width: unset;
  margin: 0;
  height: 20px;
  font-size: 10px;
}
.queue-item .notes {
  color: #9E9E9E !important;
  font-size: 10px;
  padding: 0 10px;
  margin: 0;
}
.queue-item .v-card__text i {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6) !important;
}
.tableShow {
  width:4px;
  height: 38px;
  display: inline-block;
  border-radius: 20px;
  position: absolute;
  top: 21px;
  left: 16px;
}
.tableLoanDetails {
  display: inline-block;
  margin-left: 28px;
}
.tableLoanNo {
  color:#161A40;
  font-weight: middle;
  font-size: 16px;
  height: 20px;
  margin-left: -2px;
}
.tableName {
  display: inline-block;
  color:#7E829B;
  font-size: 14px;
  height: 18px;
}
.tableRequestedAmount {
  color:#3F4360;
  font-size: 14px;
  height: 18px;
  display: inline-block;
  position: absolute;
  top: 45px;
  right: 16px;
}
.line {
  background: #E8EBF5;
  opacity: .4;
  height: 1px;
  width: 100%;
  margin-top: 12px;
}
.line-hover {
  background: #fff;
  opacity: .1;
  height: 1px;
  width: 100%;
  margin-top: 12px;
}
.locked-icon {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 18px;
  right: 12px;
}
.card-label {
  color: #C4C7D8;
  font-size: 14px;
  font-weight: normal;
}
.card-content {
  color: #7E829B;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.tableLoanNo-hover {
  color:#fff;
  font-weight: middle;
  font-size: 16px;
  height: 20px;
  margin-left: -2px;
}
.tableName-hover {
  display: inline-block;
  color:#fff;
  font-size: 14px;
  height: 18px;
}
.tableRequestedAmount-hover {
  color:#fff;
  font-size: 14px;
  height: 18px;
  display: inline-block;
  position: absolute;
  top: 45px;
  right: 16px;
}
.card-label-hover {
  color: #fff;
  font-size: 14px;
  font-weight: normal;
}
.card-content-hover {
  color: #fff;
  font-size: 14px;
  font-weight: normal;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>

<style lang="sass" scoped>
.v-card
  &__title
    font-size: unset
    line-height: unset
  &__text
    font-size: unset
    line-height: unset
</style>
